<template>

	<div class="user_wbox" style="margin-top: 0;">
		<el-container>


			<div class="inter">
				<el-row v-if="isMobile">

					<div class="mobile_addorder">
						<div class="ndiv1">
							<div class="image">
								<img src="@/assets/image/tu_biao.png" />
							</div>
							<div class="text">
								<div class="p1"> {{
									info.archives.title }}</div>
								<div class="p2">
									<span class="sp1">游戏区服</span>三角洲行动{{
										info.archives.qufu_text }}
								</div>
								<div class="p2">
									<span class="sp1">上号方式</span>{{
										info.archives.login_type_text }}
								</div>
							</div>
						</div>
						<div class="ndiv2">
							<div class="p1">
								<div class="sp1">商品价格</div>{{ info.archives.price }}
							</div>
							<div class="p1">
								<div class="sp1">押金</div>{{ info.archives.yajin }}
							</div>
							<div class="p1">
								<div class="sp1">实际支付</div>{{ parseFloat(info.archives.yajin) +
									parseFloat(info.archives.price) }}
							</div>

						</div>

						<div class="ndiv3">

							<div class="item">
								<div class="text_1">
									<div class="ic">
										<img src="@/assets/image/pay2.png" />
									</div>
									支付宝
								</div>
								<div class="text_2">
									<img src="@/assets/image/yuan2.png" />
								</div>
							</div>

						</div>


						<div class="addorder_goods_info" >
							<div class="p5" style="justify-content: center;">
								<img :src="require(`@/assets/image/radio_icon.png`)" @click="xuzhi = !xuzhi"
									v-if="!xuzhi" class="orderInfoConfirm_radio">
								<img :src="require(`@/assets/image/radio_icon_active.png`)" @click="xuzhi = !xuzhi"
									v-if="xuzhi" class="orderInfoConfirm_radio">
								<div>
									我已阅读并同意
									<span @click="visible2 = true">《购买须知》</span>
								</div>
							</div>
						</div>


						<div class="ndiv4">
							<div class="pay_order" @click="addOrder">立即支付</div>
						</div>
					</div>
				</el-row>
				<el-row v-if="!isMobile">
					<div class="add_ordxer" v-if="info.archives">
						<div class="wp1">核对订单信息</div>
						<div class="addorder_goods">
							<div class="text_1">
								<div class="item1">商品信息</div>
								<div class="item2">单价</div>
								<div class="item3">押金</div>
							</div>
							<div class="text_1 text_2">
								<div class="item1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<div class="p1"> {{
											info.archives.title }}</div>
										<div class="p2">
											<span class="sp1">游戏区服</span>三角洲行动{{
												info.archives.qufu_text }}
										</div>
										<div class="p2">
											<span class="sp1">上号方式</span>{{
												info.archives.login_type_text }}
										</div>
									</div>
								</div>
								<div class="item2">{{ info.archives.price }}元</div>
								<div class="item3">{{ info.archives.yajin }}元</div>
							</div>
						</div>
						<div class="addorder_goods_info">
							<div class="p1">
								<div class="sp1">订单金额</div>¥{{ info.archives.price }}
							</div>
							<div class="p1">
								<div class="sp1">商品押金</div>¥{{ info.archives.yajin }}
							</div>

							<div class="p3">
								<div class="text">
									<div class="sp1">实际支付:</div>
									¥{{ parseFloat(info.archives.yajin) + parseFloat(info.archives.price) }}

								</div>
							</div>

							<div class="p4">
								<div class="pay_order" @click="addOrder">立即下单</div>
							</div>
							<div class="p5">
								<img :src="require(`@/assets/image/radio_icon.png`)" @click="xuzhi = !xuzhi"
									v-if="!xuzhi" class="orderInfoConfirm_radio">
								<img :src="require(`@/assets/image/radio_icon_active.png`)" @click="xuzhi = !xuzhi"
									v-if="xuzhi" class="orderInfoConfirm_radio">
								<div>
									我已阅读并同意
									<span @click="visible2 = true">《购买须知》</span>
								</div>
							</div>


						</div>
					</div>

				</el-row>
			</div>
		</el-container>





		<el-dialog :visible.sync="visible2" :center="true" title="购买须知" width="600px" destroy-on-close
			@closed="visible2 = false">
			<div class="compensationModel_box">
				<div v-html="config.jiaoyi">

				</div>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="payvisible" :center="true" custom-class="pay_dialog" title="收银台" width="544px"
			destroy-on-close @closed="close">
			<div class="pay_dialog_page">
				<div class="scan_operat">
					<div class="scan_area" v-if="pay_type == 1">
						<p class="scan_area_title">请打开支付宝扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_area" v-if="pay_type == 2">
						<p class="scan_area_title">请打开微信扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk" v-if="pay_show">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_control">
						<p class="scan_control_price">
							应付金额：
							<span>¥{{ pay_info.price }}</span>
						</p>
						<div class="scan_control_option" @click="openPay(1)">
							<div>

								<img :src="require(`@/assets/image/alipay.png`)" alt="ALIPAY">
								<span>支付宝</span>
							</div> <img v-if="pay_type == 1" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 1" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">

						</div>
						<!-- <div class="scan_control_option" @click="openPay(2)">
							<div>
								<img :src="require(`@/assets/image/wechat.png`)" alt="wechat">
								<span>微信支付</span>
							</div> <img v-if="pay_type == 2" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 2" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">
						</div> -->

						<p class="scan_control_tips">为确保您当前交易的安全，扫描二维码后会进行安全验证！</p>
					</div>
				</div>
			</div>
		</el-dialog>



	</div>


</template>
<script>
import {
	Notification,
	Message
} from 'element-ui'
import QRCode from 'qrcodejs2';
export default {
	data() {
		return {
			goods: {},
			goods_id: 0,
			loading: true,
			info: {},
			daqu: {},
			baopei_type: 0,
			shouxufei: 0,
			price: 0,
			visible: false,
			visible2: false,
			jiaoyi: {},
			xuzhi: false,
			payvisible: false,
			pay_info: {},
			pay_type: 1,
			order_id: 0,
			pay_show: false

		}
	},
	computed: {


		login() {
			return this.$store.getters.login
		},
		open_login() {
			return this.$store.getters.open_login
		},

		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		config() {
			return this.$store.getters.config
		},
	},
	created: function (data) {

		this.goods_id = this.$route.query.id

		if (this.goods_id == undefined) {
			this.goods_id = this.$route.params.id
		}




		this.getDetail(this.goods_id);



	},
	watch: {


		baopei_type(v) {

			if (v == 1) {
				var now_price = parseFloat(this.goods.price * 0.1).toFixed(2);
				this.price = parseFloat(this.goods.price) + parseFloat(now_price)
			} else if (v == 2) {
				var now_price = parseFloat(this.goods.price * 0.2).toFixed(2);
				this.price = parseFloat(this.goods.price) + parseFloat(now_price)
			} else if (v == 3) {
				var now_price = parseFloat(this.goods.price * 0.05).toFixed(2);
				this.price = parseFloat(this.goods.price) + parseFloat(now_price)
			} else {
				this.price = this.goods.price
			}


		},
		$route() {

		}
	},
	methods: {
		openPay(item) {
			this.pay_type = item

			this.payOrder(this.order_id)
		},
		changeType(item) {
			this.baopei_type = item
		},
		close() {
			this.payvisible = false;
			var that = this;
			setTimeout(function () {
				that.$router.push("/order")

			}, 500);
		},

		getDetail(id) {
			var that = this;

		},

		payOrder(id) {
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					that.pay_show = false
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
					return;
					that.payvisible = true
					that.pay_info = res.data
					that.pay_show = true
					setTimeout(function () {
						var qrcodeElement = document.getElementById("qrcodePay");
						qrcodeElement.innerHTML = "";
						if (that.pay_type == 1) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.qr_code,
								width: 130,
								height: 130
							});

						}

						if (that.pay_type == 2) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.code_url,
								width: 130,
								height: 130
							});
						}


					}, 500);

					const intervalId = setInterval(() => {
						this.rq.requests.post("api/game/order/detail", {
							id: id,
						}).then(res => {
							if (res.data.status == '1') {
								clearInterval(intervalId);
								that.$router.push("/order")
							}
						}).catch(error => {
							clearInterval(intervalId);
						})
					}, 5000);
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},


		payOrderMobile(id) {
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder2", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},

		addOrder() {

			if (this.xuzhi == false) {
				Message.error({
					message: "请阅读并勾选购买须知",
					duration: 3000,
					offset: "580"
				})
				return;
			}

			var xuzhi = 0;
			if (this.xuzhi) {
				xuzhi = 1
			}

			var baobei = 0;
			if (this.baopei_type) {
				baobei = 1
			}


			var that = this;
			this.rq.requests.post("api/game/order/addorder", {
				id: that.goods_id,
				baopei: this.baopei_type,

			}).then(res => {

				that.order_id = res.data.id
				// if (res.data.status == 1) {
				// 	// that.$router.push("/orderDetail?id=" + res.data.id)
				// 	return;
				// } else {
				// 	that.payOrder(res.data.id)
				// }
				if(!this.isMobile){
					that.payOrder(res.data.id)
				}else{
					that.payOrderMobile(res.data.id)
				}

			}).catch(res => {


				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},
		getDetail(id) {
			var that = this;
			this.rq.requests.post("api/game/hall/ArchivesDetail", {
				id: id,
			}).then(res => {


				that.info = res.data;
				that.shouxufei = 0;
				that.price = that.goods.price
				that.loading = false;

			}).catch(error => {

			})
		},


	}
}
</script>
<style>
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #508aff;
	background: #508aff;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #508aff;
}
</style>